import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withStyles } from '@material-ui/core/styles'
import {
  handleSubjectChange,
  clickContactToEmail,
/*handleMultiChange*/
} from '../../actions/email'
import { contactsWithEmailsSelector } from '../../selectors'
import Select from 'components/theme/Select'
import TextField from '@material-ui/core/TextField'
import language from 'utils/vast-languagepack'

const mapStateToProps = (state) => ({
  contacts: contactsWithEmailsSelector(state),
  location: state.router.location,
  email: state.email,
})

const mapDispatchToProps = dispatch => bindActionCreators({
  handleSubjectChange,
  clickContactToEmail,
  // handleMultiChange,
}, dispatch)

const styles = theme => ({
  paper: {
    padding: "10px 25px 10px 10px",
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
  },
})

class EmailFields extends Component {

  handleChange = name => event => {
    this.props.handleSubjectChange(name, event.target.value)
  }

  handleInputChange = (newValue) => {
    this.setState({ newValue })
  }

  render() {
    const { classes } = this.props

    return (
      <div>
        <Select
          value={this.props.toValue}
          onChange={newValue => this.props.handleMultiChange(newValue)}
          closeMenuOnSelect={false}
          isMulti
          options={this.props.contacts}
          placeholder={language.emailPage.placeholder.to}
        />
        <TextField
          label={language.emailPage.labels.subject}
          fullWidth
          value={this.props.email.subject}
          onChange={this.handleChange('subject')}
          className={classes.textField}
          margin="normal"
        />
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(EmailFields))
